import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import VisibilitySensor from 'react-visibility-sensor'

import video from '../../video/editor.mp4'

let videoRef = null

const PlatformsBlock = ({ t }) => {
    const [play, setPlay] = useState(false)

    function onChange(isVisible) {
        if (isVisible && videoRef && !play) {
            setPlay(true)

            const videoPlayPromise = videoRef.play()

            if (videoPlayPromise !== undefined) {
                videoPlayPromise
                    .then(() => {
                        // Automatic playback started
                    })
                    .catch(err => {
                        videoRef.setAttribute('controls', 'controls')
                    })
            }
        }
    }

    return (
        <div className="home__platforms-block">
            <h3 className="dark">{t('_pages._home._platforms_block.title')}</h3>
            <p>{t('_pages._home._platforms_block.subtitle')}</p>
            <div className="device">
                <VisibilitySensor onChange={onChange} partialVisibility={true}>
                    <div className="notebook">
                        <ul className="balls balls--left">
                            <li className="ball ball--1"></li>
                            <li className="ball ball--2"></li>
                            <li className="ball ball--3"></li>
                            <li className="ball ball--4"></li>
                        </ul>
                        <ul className="balls balls--right">
                            <li className="ball ball--1"></li>
                            <li className="ball ball--2"></li>
                            <li className="ball ball--3"></li>
                        </ul>
                        <div className="screen">
                            <video
                                width="852"
                                height="auto"
                                loop="loop"
                                ref={el => (videoRef = el)}
                                muted="muted"
                                playsInline
                            >
                                <source src={video} type="video/mp4;" />
                            </video>
                        </div>
                        <div className="pad"></div>
                    </div>
                </VisibilitySensor>
            </div>
        </div>
    )
}

export default withTranslation('translations')(PlatformsBlock)
